export const SYNC_OK = 'ok'
export const SYNC_FAILED = 'failed'

export type SyncStatus = typeof SYNC_OK | typeof SYNC_FAILED

export type SyncErrorCategory =
  | 'sftp_unreachable'
  | 'sftp_read'
  | 'invalid_file'
  | 'azure'
  | 'unknown'
  // Derived by the backend from the age of the last attempt, never stored:
  // the job that would record it is the one that is not running.
  | 'scheduler_stalled'

/**
 * Payload of GET /api/data-sync-status/, camelCased by the axios wrapper.
 *
 * `lastSuccessAt` is the last run that completed, including the runs that
 * found nothing; `dataReceivedAt` is when data last actually arrived. The two
 * are deliberately separate: with a run every 30 minutes and a delivery once
 * a day they answer different questions.
 */
export type DataSyncStatus = {
  status: SyncStatus
  consecutiveFailures: number
  lastCheckedAt?: string
  // When the next scheduled run is due: lastCheckedAt + the sync interval.
  nextCheckAt?: string
  lastSuccessAt?: string
  errorCategory?: SyncErrorCategory
  errorDetail?: string
  dataReceivedAt?: string
  registryFileName?: string
  dataIngestionId?: number
  salesStartDate?: string
  salesEndDate?: string
}
